module.exports = __webpack_public_path__ + "newslaundry_logo-a30b25d52b04ea0a0b52.png";